import { ApolloClient, InMemoryCache } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'

export const GraphqlClient = () => {
  let token = ''
  let user: any = localStorage.getItem('user')

  if (user !== 'null' && user != null) {
    user = JSON.parse(user)
    token = user.token
  }

  const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_URL,
    cache: new InMemoryCache({
      addTypename: false
    }),
    headers: {
      authorization: token
    }
  })

  return client
}

export const FileUploadGraphqlClient = () => {
  let token = ''
  let user: any = localStorage.getItem('user')

  if (user !== 'null' && user != null) {
    user = JSON.parse(user)
    token = user.token
  }

  const uploadLink: any = createUploadLink({
	  uri: process.env.REACT_APP_GRAPHQL_URL
	})
  
	const client = new ApolloClient({
	  link: uploadLink,
	  cache: new InMemoryCache({
      addTypename: false
    }),
    headers: {
      authorization: token
    }
	})

  return client
}
